import React from "react";
// import Select from 'react-select';
import Select from "@material-ui/core/Select";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import SelectMui from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { UserType } from "../constants/common";
import Whatsapp from "../../../assets/images/watsapp.png";
import fbmsngr from "../../../assets/images/fbmsngr.png";
import slack from "../../../assets/images/slack.png";
import line from "../../../assets/images/line.png";
import telegram from "../../../assets/images/telegram.png";
import webchat from "../../../assets/images/webchat.png";
import { getData } from "../../../dataProvider/apiHandler";
import { submit } from "./formActions";
import { FormButtons } from "./formbuttons";
import FindError from "../../../dataProvider/errorHandler";
import closeIconRed from "./../../../assets/images/close_red.png";

const serverUrl = window._env_.REACT_APP_SXP_URL;

const langLists =[
  { label:'English', value:'en'},
  { label:'Telugu', value:'te'},
  { label: 'Hindi', value:'hi'}
]

export class Notification extends React.Component {
  state = {
    notificationMessage:[{lang:'en'}],
    filteredLangList:[],
    selectedLangInOption:'',
    viewMore:false,
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let propsState;

    if(nextProps.data.data.notificationMessage){
      if(!Array.isArray(nextProps.data.data.notificationMessage) ){
        let objectttt = Object?.keys(nextProps.data.data.notificationMessage).map(lang => ({ lang, label: nextProps.data.data.notificationMessage[lang] }));
        nextProps.data.data.notificationMessage =  objectttt;
      }
    }

    if (
      currentState.formUniqueId &&
      currentState.formUniqueId === nextProps.formUniqueId
    ) {
      propsState = { ...(nextProps.data.data || {}), ...currentState };
    } else {
      propsState = { ...currentState, ...(nextProps.data.data || {}) };
    }
    propsState.formUniqueId = nextProps.formUniqueId;
    propsState.conversations = nextProps.conversations;
    let userType = propsState.userType;
    if (userType === UserType.REGISTERED) {
      propsState.showRegisteredUserElements = true;
    } else if (userType === UserType.DIRECT) {
      propsState.showDirectChannelElements = true;
    } else {
      propsState.showRegisteredUserElements = false;
      propsState.showDirectChannelElements = false;
    }
    if (propsState.conversations) {
      let conversation = propsState.conversations.find(
        (x) => x.value === propsState.dialogId
      );
      if (conversation) propsState.conversationObj = conversation;
    }   
    return propsState;
  }

  componentDidMount = () => {
    this.getChannels();
    this.filterLangList();
  };

  componentWillUnmount() {
    this.setState({});
  }

  getChannels = async () => {
    this.setState({ loadingCard: true });
    try {
      const allOption = {
        url: serverUrl + "channel-config/" + localStorage.getItem('pId'),
        params: { projectId: localStorage.getItem("pId") },
      };
      let initialLoad = await getData(allOption);
      this.setState({
        allchannelsList: initialLoad.data.data.docs.map((d) => d.name),
        totalPages: initialLoad.data.data.pages,
        loadingCard: false,
      });
    } catch (e) {
      const errorObj = FindError(e)
      this.setState({
        displayToast: true,
        messageToast: errorObj.message,
        severity: "error",
        confirmAlert: false,
      });
    }
  };

  handleSelectChange = (e) => {
    let updatedState = { ...this.state };
    updatedState.dialogId = e.value;
    this.setState(updatedState);
  };

  handleUserTypeChange = (e) => {
    let userType = e.target.value;
    if (userType === UserType.REGISTERED) {
      this.setState({
        showRegisteredUserElements: true,
        userType: UserType.REGISTERED,
      });
    } else if (userType === UserType.DIRECT) {
      this.setState({
        showDirectChannelElements: true,
        userType: UserType.DIRECT,
      });
    } else {
      this.setState({
        showRegisteredUserElements: false,
        showDirectChannelElements: false,
        userType: UserType.TRANSACTIONAL,
      });
    }
  };

  handleDialogCheckBox = () => {
    let flag = this.state.isDialog ? true : false;
    this.setState({ isDialog: !flag });
  };

  handleTransactionalConv = () => {
    let flag = this.state.transactionalConversation ? true : false;
    this.setState({transactionalConversation : !flag });
    if(flag)
    {
      this.setState({transactionId:''})
    }
  }

  handleChange = async (event) => {
    this.setState({ channels: event.target.value });
  };

  handleNotifMessageChange = (e) => {
    this.setState({
      notificationMessage: {
        ...this.state.notificationMessage?.en,
        en: e.target.value,
      },
    });
  };

  handleAddLang = (e) => {
    if(e.target.value !== ''){
      let arr = [...this.state.notificationMessage];
      arr.push({lang:e.target.value});
      this.setState({notificationMessage : arr}, () => this.filterLangList());
      this.setState({selectedLangInOption: e.target.value})
   } 
  }

  handleLanguageChange = (e, i, lang) => {
    let arra = [...this.state.notificationMessage];
    arra[i].label = e.target.value;
    this.setState({notificationMessage: arra})
  }

  filterLangList = () => {
    let allExistsLangs = this.state.notificationMessage.map(d => d.lang);
    const allLangs = langLists.map(d => d.value);
    let setAllLangData = new Set(allExistsLangs);
    let filteredLangList = allLangs.filter((x) => !setAllLangData.has(x));
    this.setState({filteredLangList: filteredLangList})
  }

  removeLang = (i) => {
    let arr = [...this.state.notificationMessage];
    arr.splice(i, 1);
    this.setState({notificationMessage : arr}, () => this.filterLangList());
  }

  fakeClick = () => {
    console.log('haha..! Bingo !! Click not allowed here...')
  }

  viewMoreHandle = (e) => {
    let statusVal = e.target.checked;
    this.setState({ viewMore: statusVal });
  };


  render() {
    return (
      <form
        className="form-style"
        onSubmit={(e) => submit(e, this.props, { ...this.state })}
      >
        <div>
          <label> Name </label>
          <input
            type="text"
            name="name"
            defaultValue={this.state.name}
            key={this.state.formUniqueId}
            required
            autoFocus
          />
        </div>

        <div>
          <label> User Type: </label>

          <Select
            name="userType"
            defaultValue={
              this.state.userType ? this.state.userType : "transactional"
            }
            key={this.state.formUniqueId}
            onChange={this.handleUserTypeChange}
            className="sxp-defaultDropDown_filed w100"
          >
            <MenuItem value={UserType.TRANSACTIONAL}>TRANSACTIONAL</MenuItem>
            <MenuItem value={UserType.REGISTERED}>REGISTERED</MenuItem>
            <MenuItem value={UserType.DIRECT}>DIRECT CHANNEL</MenuItem>
          </Select>
        </div>

        <div>
          <label> Add a Notification Language : </label>
          <div className="pos-rel">
            <Select
              className="sxp-defaultDropDown_filed w100"
              value={this.state.selectedLangInOption}
              onChange={this.handleAddLang}
            >
              <MenuItem value="">Select a Language</MenuItem>
              {this.state.filteredLangList.map((d,i) => (
                <MenuItem key={i} value={d}>{d}</MenuItem>
              ))}
              
            </Select>
            <FormHelperText className="projSelectPlaceholder">
              Select a Language
            </FormHelperText>
          </div>
        </div>
        {/* <div>
          <label> Message:</label>
          <textarea
            name="notificationMessage"
            defaultValue={this.state.notificationMessage?.en}
            value={this.state.notificationMessage?.en}
            onChange={this.handleNotifMessageChange}
            rows="6"
            cols="30"
            key={this.state.formUniqueId}
          />
        </div> */}
         <div className="display-flex">
            <label>Message </label>
          </div>
            {this.state.notificationMessage.map((d,i) => (
              <div className="flex langQuestion" key={i} style={{alignItems:'baseline'}}>
              <span className="spanTextHolder">{d.lang}</span>
              <input
                type="text"
                name="notificationMessage"
                id={`notificationMessage${d.lang}`}
                defaultValue={d?.label}
                value={d?.label}
                onChange={(e) => this.handleLanguageChange(e, i, d.lang)}
                key={this.state.formUniqueId}
                required
              />
              <span 
                className={`langCloseIcon ${d.lang === 'en' ? 'disablePagBtn':null}`} 
                onClick={() => d.lang === 'en' ? this.fakeClick() : this.removeLang(i)}>
                  <img src={closeIconRed} />
                </span>
            </div>
            ))}

        <Tabs>
          <TabList>
            <Tab>Input</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <label>
              Formatted Message:
              <textarea
                name="richText"
                defaultValue={this.state.richText?.en}
                rows="6"
                cols="30"
                onChange={(e) =>
                  this.setState({
                    richText: {
                      ...this.state.richText?.en,
                      en: e.target.value,
                    },
                  })
                }
                key={this.state.formUniqueId}
              />
            </label>
          </TabPanel>
          <TabPanel>
            {this.state.richText && (
              <div
                style={{ border: "2px solid black", padding: 5 }}
                dangerouslySetInnerHTML={{ __html: this.state.richText?.en }}
              />
            )}
          </TabPanel>
        </Tabs>

        {(this.state.showRegisteredUserElements ||
          this.state.showDirectChannelElements) && (
          <>
            <div>
              <label>
                {this.state.showDirectChannelElements
                  ? "User Channel ID"
                  : "User ID"}
              </label>
              <input
                type="text"
                name="authenticatedUserId"
                defaultValue={this.state.authenticatedUserId}
                key={this.state.formUniqueId}
                required
                autoFocus
              />
            </div>
            <label> Channel: </label>
            <FormControl className="notifi_channel">
              <SelectMui
                className="channel-select-dd"
                labelId="demo-mutiple-checkbox-label"
                id="demo-mutiple-checkbox"
                multiple
                disableUnderline
                value={this.state.channels || []}
                renderValue={(selected) =>
                  " Selected " + selected.length + "Channels"
                }
                onChange={this.handleChange}
                onClose={this.handleChangeBlur}
                inputProps={{ "aria-label": "Without label" }}
              >
                {this.state.allchannelsList
                  ? this.state.allchannelsList.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={this.state.channels?.indexOf(name) > -1}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))
                  : []}
              </SelectMui>
              {this.state.channels?.length ? (
                ""
              ) : (
                <FormHelperText className="selectChannelButton">
                  Select Channel
                </FormHelperText>
              )}
            </FormControl>
            <div className="flex-box-header">
              {this.state.channels
                ? this.state.channels.map((item) =>
                    item.includes("whatsapp") ? (
                      <img src={Whatsapp} className="channel-box" />
                    ) : null
                  )
                : []}
              {this.state.channels
                ? this.state.channels.map((item) =>
                    item.includes("facebook") ? (
                      <img src={fbmsngr} alt="facebookIcon" className="channel-box" />
                    ) : null
                  )
                : []}
              {this.state.channels
                ? this.state.channels.map((item) =>
                    item.includes("slack") ? (
                      <img src={slack} alt="slackIcon" className="channel-box" />
                    ) : null
                  )
                : []}
              {this.state.channels
                ? this.state.channels.map((item) =>
                    item.includes("line") ? (
                      <img src={line} alt="lineIcon" className="channel-box" />
                    ) : null
                  )
                : []}
              {this.state.channels
                ? this.state.channels.map((item) =>
                    item.includes("telegram") ? (
                      <img src={telegram} alt="telegramIcon" className="channel-box" />
                    ) : null
                  )
                : []}
              {this.state.channels
                ? this.state.channels.map((item) =>
                    item.includes("webchat") ? (
                      <img src={webchat} alt="webChatIcon" className="channel-box" />
                    ) : null
                  )
                : []}
            </div>
           
            <input
              type="checkbox"
              key={this.state.formUniqueId}
              defaultChecked={this.state.isDialog ? true : false}
              name="isDialog"
              onChange={this.handleDialogCheckBox}
            /><label> Start Conversation? </label>

            {(this.state.userType === 'REGISTERED' || this.state.userType === 'DIRECT') && this.state.isDialog && ( 
              <>
            <div>
              <label> Transferable State </label>
              <input
                type="text"
                name="transferableStateVars"
                defaultValue={this.state.transferableStateVars}
                key={this.state.formUniqueId}
              />
            </div>
              <div>
                <input
                type="checkbox"
                key={this.state.formUniqueId}
                defaultChecked={this.state.transactionalConversation ? true: false}
                name="transactionalConversation"
                onChange={this.handleTransactionalConv}
                />
                <label>Transactional Conversation?</label>
              </div>
              {this.state.transactionalConversation && (
                <>
                <label>Transaction Id</label>
                <input 
                type="text"
                name="transactionId"
                defaultValue={this.state.transactionId}
                key={this.state.formUniqueId}
                />
                </>
              )}
            </>
            )}
            
            {this.state.isDialog && (
              <>
                <label> Conversation:</label>
                <Select
                  name="dialogId"
                  defaultValue={this.state.conversationObj?.value}
                  key={this.state.formUniqueId}
                  onChange={this.handleSelectChange}
                  className="sxp-defaultDropDown_filed w100"
                >
                  {this.state.conversations.map((d,i)=> (
                    <MenuItem value={d.value}>{d.label}</MenuItem>
                  ))}
                  
                </Select>
              </>
            )}
          </>

          
        )}
        <div>
          <input
            type="checkbox"
            key={this.state.formUniqueId}
            defaultChecked={
              this.state.viewMore === true ? true : false
            }
            name="viewMore"
            onChange={this.viewMoreHandle}
          />
          <label>View More </label>
        </div>

        <FormButtons formProps={this.props} />
      </form>
    );
  }
}
